
    import emitter from '../event/eventBus';
    import { computed, defineComponent, Prop, PropType, reactive, toRefs } from 'vue';
    export default defineComponent({
        props:{
            nativeType:{
                type:String as PropType<string>,
                default:"button",
                // validator 的参数一定要注明类型,否则会破坏setup函数的props对象的类型
                validator:(val:string) => {
                    return ["submit","button","reset"].indexOf(val) > -1;
                }
            },
            type:{
                type:String as PropType<String>,
                default:"default",
                validator:(val:string) => {
                    return ["default","success","primary","error","info","warning"].indexOf(val as string) > -1;
                }
            },
            size:{
                type:String as PropType<String>,
                default:"normal",
                validator:(val:string) => {
                    return ["mini","medium","normal","small","large"].indexOf(val as string) > -1;
                }
            },
            isLong:{
                type:Boolean as PropType<Boolean>,
                default:false
            },
            content:String as PropType<String>,
            isRenderHTML:{
                type:Boolean as PropType<Boolean>,
                default:false
            },
            clickType:String as PropType<string>,
            style:String as PropType<string>
        },
        setup(props){
            const { nativeType,isRenderHTML,content,type,size,isLong } = toRefs(props);
            const state = reactive({
                nativeType:nativeType.value,
                isRenderHTML:isRenderHTML.value,
                content:content.value
            });
            const classObject = computed(() => {
                const defaultClassName = "btn";
                return `${ defaultClassName } btn-${type.value} ${ ( isLong.value ? "btn-long " : "") }btn-${ size.value }`;
            });
            const onClickHandler = () => {
                emitter.$emit("on-click",() => props.clickType);
            }
            const topStyle = computed(() => ({ "display":props.style }));
            return {
                ...toRefs(state),
                classObject,
                topStyle,
                onClickHandler
            }
        }
    })
